var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 20,
    viewBox: "0 0 55 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6817 19.7369C46.1474 19.7369 43.3701 18.716 41.2524 16.9294L42.2245 15.5803C44.2727 17.1482 46.5987 18.0597 48.6817 18.0597C51.2854 18.0597 53.2989 16.6012 53.2989 14.7417C53.2989 12.6269 51.6325 11.5331 48.3345 10.5122C44.0297 9.12663 42.3634 7.6317 42.3634 5.07939C42.3634 2.16246 45.0712 0.0112305 48.404 0.0112305C50.5563 0.0112305 52.8823 0.813385 54.8264 2.126L53.8891 3.51154C52.1533 2.34477 50.1745 1.68846 48.404 1.68846C46.0433 1.68846 44.0644 3.03754 44.0644 4.86062C44.0644 6.6837 45.5225 7.70462 49.1677 8.90786C52.917 10.1475 55 11.5696 55 14.5229C55 17.4763 52.1533 19.7369 48.6817 19.7369Z",
    fill: "#5F39DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1846 9.87419C17.1846 4.41932 21.6143 0 27.0754 0C32.5364 0 36.9662 4.41932 36.9662 9.87419C36.9662 15.3291 32.5364 19.7484 27.0754 19.7484C21.6143 19.7484 17.1846 15.3291 17.1846 9.87419ZM27.0754 1.73795C22.5712 1.73795 18.9225 5.38218 18.9225 9.87419C18.9225 14.3662 22.5712 18.0104 27.0754 18.0104C31.5796 18.0104 35.2282 14.3662 35.2282 9.87419C35.2282 5.38218 31.5796 1.73795 27.0754 1.73795Z",
    fill: "#5F39DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.4505C0 17.9706 0.389053 17.5815 0.868974 17.5815H12.0389C12.5188 17.5815 12.9078 17.9706 12.9078 18.4505C12.9078 18.9304 12.5188 19.3195 12.0389 19.3195H0.868974C0.389053 19.3195 0 18.9304 0 18.4505Z",
    fill: "#5F39DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.29769C0 0.817764 0.389053 0.428711 0.868974 0.428711H12.0389C12.5188 0.428711 12.9078 0.817764 12.9078 1.29769C12.9078 1.77761 12.5188 2.16666 12.0389 2.16666H0.868974C0.389053 2.16666 0 1.77761 0 1.29769Z",
    fill: "#5F39DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.8741C0 9.39418 0.389053 9.00513 0.868974 9.00513H12.0389C12.5188 9.00513 12.9078 9.39418 12.9078 9.8741C12.9078 10.354 12.5188 10.7431 12.0389 10.7431H0.868974C0.389053 10.7431 0 10.354 0 9.8741Z",
    fill: "#5F39DE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2a60975.svg";
export { ForwardRef as ReactComponent };